import Spinner from '../../spinner';
import { Achievement } from '../Achievement';
import { AchievementGuestData } from '../types';
import styles from './styles.module.scss';

export const AchievementList = ({
  activeAchievements,
  archiveAchievements,
  isLoading
}: {
  activeAchievements: AchievementGuestData[],
  archiveAchievements: AchievementGuestData[],
  isLoading: boolean,
}) => {

  if (isLoading)
    return (
      <div className={"w-100 mb-5"} style={{ height: "400px" }}>
        <Spinner toggled={true} background={true} />
      </div>
    );

  return (
    <div className="container">
      <div className={styles.AchievementList}>
        <div className={styles.AchievementList_type}>
          <h2 className={styles.title}>Активные</h2>
          <ul>
            {
              activeAchievements.map((ach, i) => (
                <li key={i}>
                  <Achievement
                    isActive={true}
                    achievement={ach}
                    withPopup
                  />
                </li>
              ))
            }
          </ul>
        </div>

        <div className={styles.AchievementList_type}>
          <h2 className={styles.title}>Архив</h2>
          <ul>
            {
              archiveAchievements.map((ach, i) => (
                <li key={i}>
                  <Achievement
                    isActive={false}
                    achievement={ach}
                    withPopup
                  />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  )
};